import { TFunction } from 'i18next'

import { TransactionsPaymentsActionItem } from '../types/paymentsActionItem'

export enum TransactionsPaymentsActionType {
  Void = 'void',
}

interface GetPaymentsActionsProps {
  t: TFunction
}

export const getPaymentsActions = ({ t }: GetPaymentsActionsProps) => {
  const items: TransactionsPaymentsActionItem[] = [
    {
      children: t('transactions.table.static_actions.payments.void'),
      id: TransactionsPaymentsActionType.Void,
      value: TransactionsPaymentsActionType.Void,
    },
  ]

  return items
}
